import { DatePipe } from '@angular/common';
import { Component, OnInit,Input,OnChanges,SimpleChanges } from '@angular/core';
import {ApplicationTitleConfig} from 'src/app/main/shared/constants/application-title-cnst'
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
  selector: 'app-application-title',
  templateUrl: './application-title.component.html',
  styleUrls: ['./application-title.component.scss']
})
export class ApplicationTitleComponent implements OnInit,OnChanges {

  @Input() applicationName;
  @Input() componentName;
  @Input() source;
  @Input() timeStamp;
  applicationtitle : string;
  lastProcessedTime : string;
  titleTag = {
    'windspeed' : ' - 10m above surface',
    // 'rainfall' : '',
    'temperature' : ' - 2m above surface',
    'humidity' : ' - 2m above surface',
  }
  displaytime: any;

  constructor(private utils : UtilsService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.applicationtitle = ApplicationTitleConfig[this.applicationName][this.componentName]['title']
    this.utils.getLastProcessedTime().subscribe(data =>{
      if(ApplicationTitleConfig[this.applicationName][this.componentName]['processedTime'])
       this.lastProcessedTime = data;
    })
    let postdata ={
      "limit" : 1,
    "sourceList" : ["IMD_RADAR_MODEL_INPUT_NOWCAST", "CTT_MODEL_INPUT_NOWCAST", "EUMETSAT_MODEL_INPUT_NOWCAST", "MODEL_INPUT_NOWCAST"],
    "component": 'SEAMLESS'
    }
    this.utils.getTimeNowcastData(postdata).subscribe(data => {
        if (this.componentName === 'cyclone forecast') {
          this.displaytime = this.formatDateString(Number(Object.keys(data['IMD_RADAR_MODEL_INPUT_NOWCAST'])[0]));
        } else if (this.componentName === 'cloud cover') {
          this.displaytime = this.formatDateString(Number(Object.keys(data['CTT_MODEL_INPUT_NOWCAST'])[0]));
        } else if (this.componentName === 'cloud top temperature') {
          this.displaytime = this.formatDateString(Number(Object.keys(data['EUMETSAT_MODEL_INPUT_NOWCAST'])[0]));
        }
    })
  }

  ngOnChanges(SimpleChanges){
    if(SimpleChanges.componentName) {
    this.lastProcessedTime = null    
    this.applicationtitle = ApplicationTitleConfig[this.applicationName][this.componentName]['title']
  }
  }

  formatDateString(timestamp: number): string {
    let date = new Date(timestamp);    
    return this.datePipe.transform(date, 'dd-MMM-yyyy hh:mm a', '+0530');
  }

  formatTimestamp(timestamp: number): string {
    const date = new Date(Number(timestamp));
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    return date.toLocaleDateString('en-GB', options);
  }

}
